import React from "react";
import { useTranslation } from "react-i18next";
import {
  FaRegHospital,
  FaClinicMedical,
  FaBoxes,
  FaUniversity,
  FaTruck,
  FaShoppingCart
} from "react-icons/fa";
import "./EsmInnovation.scss";
import logoEsm from "../../../images/Logo/logoESM.png";

const EsmConnection = () => {
  const { t } = useTranslation();

  const nodes = [
    { id: 1, icon: <FaRegHospital />, label: t("esm_implementation.conn_hospital") },
    { id: 2, icon: <FaClinicMedical />, label: t("esm_implementation.conn_clinic") },
    { id: 3, icon: <FaBoxes />, label: t("esm_implementation.conn_supply_chain") },
    { id: 4, icon: <FaUniversity />, label: t("esm_implementation.conn_bank") },
    { id: 5, icon: <FaTruck />, label: t("esm_implementation.conn_other_suppliers") },
    { id: 6, icon: <FaShoppingCart />, label: t("esm_implementation.conn_non_medical") },
  ];

  const totalNodes = nodes.length;

  const getLabelClass = (angle) => {
    // Normalizing angle to 0-360
    let a = angle % 360;
    if (a < 0) a += 360;
    
    if (a === 0) return "label-right";
    if (a > 0 && a < 90) return "label-bottom-right";
    if (a === 90) return "label-bottom";
    if (a > 90 && a < 180) return "label-bottom-left";
    if (a === 180) return "label-left";
    if (a > 180 && a < 270) return "label-top-left";
    if (a === 270) return "label-top";
    return "label-top-right"; // 270-360
  };

  return (
    <div className="innov-container">
      <div className="innov-title">
        {t("esm_implementation.connection_title", "Gia tăng kết nối chuỗi liên kết")}
      </div>

      <div className="innov-canvas">
        {/* The background ring */}
        <div className="innov-ring"></div>

        {/* Center Node (ESM Logo) */}
        <div className="innov-center-node" style={{ padding: '15px' }}>
          <img src={logoEsm} alt="ESM" style={{ width: '100%', height: 'auto' }} />
        </div>

        {/* Orbiting Nodes */}
        {nodes.map((node, index) => {
          // Calculate angle for positioning. Start at top (270 degrees)
          // 270 is -90 in standard math
          const angle = (index * 360) / totalNodes - 90;
          const rad = (angle * Math.PI) / 180;
          // Radius of the orbit is 35% of the container
          const R = 35; 
          
          const x = 50 + R * Math.cos(rad);
          const y = 50 + R * Math.sin(rad);

          return (
            <div
              key={node.id}
              className={`innov-node ${getLabelClass(angle)}`}
              style={{
                left: `${x}%`,
                top: `${y}%`,
              }}
            >
              <div className="node-circle">{node.icon}</div>
              <div className="node-label">{node.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EsmConnection;
